<script>
export default {
  name: 'has-url-field',
  methods: {
    openUrl (urlToOpen) {
      if (!urlToOpen) {
        return;
      }

      if (urlToOpen.indexOf('http://') === 0 || urlToOpen.indexOf('https://') === 0) {
        let win = window.open(urlToOpen, '_blank');
        win.focus();
      } else {
        let win = window.open('https://' + urlToOpen, '_blank');
        win.focus();
      }
    }
  }
}
</script>
